import { Button, Checkbox, Input, Option, Select } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import moment from 'moment';
import { Switch as LSwitch } from '@/components/index';
import { EventBus } from '@/services/Event.js';
import store from '@/services/store';

const svc = new ResourceSvc();

export default {
    name: 'dashboardMembershipCard',
    props: ['userId'],
    components: {
        [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Button.name]: Button, [Checkbox.name]: Checkbox, LSwitch, Checkbox
    },
    data() {
        return {
            isProcessing: false,
            isUserMarkedCardForReissue: false,
            isRequestedReissue: false,
            loadedUserId: 0,
            errorMessage: null,
            user: {},
            logo: require("../../../../../../images/logo-horizontal.png"),
        };
    },
    methods: {
        getData() {
            var self = this;
            EventBus.$emit("user-load-dashboard-card", self.loadedUserId);
            this.user = store.getters.getUserShortInfo;
            this.checkIfCardMarkedForReissue();
        },
        loadPDF() {
            var doc = new jsPDF();
            var source = window.document.getElementById("membershipCard");
            var logo = document.getElementById("logo");
            doc.setLineWidth(1);
            doc.line(70, 28, 150, 28);
            doc.addImage(logo.src, 'JPEG', 75, 32, 70, 33);
            //doc.setLineWidth(12);
            //doc.line(70, 75, 150, 75);
            doc.roundedRect(70, 70, 80, 12, 3, 3, 'F');
            doc.setTextColor('#FFFFFF');
            doc.setFontSize(13);
            doc.text("TEMPORARY MEMBERSHIP", 72.5, 78);
            doc.fromHTML(source, 72, 80);
            doc.setLineWidth(1);

            var lineHeight = 7

            var addHeightOfName = lineHeight;
            if (this.user.details.moreFullNameSplitted && this.user.details.moreFullNameSplitted.length) {
                addHeightOfName = this.user.details.moreFullNameSplitted.length * lineHeight;
            }

            var addHeightOfMembership = lineHeight;
            if (this.user.membership.labelSplitted && this.user.membership.labelSplitted.length) {
                addHeightOfMembership = this.user.membership.labelSplitted.length * lineHeight;
            }

            doc.line(70, 123 + addHeightOfName + addHeightOfMembership, 150, 123 + addHeightOfName + addHeightOfMembership);
            doc.save("membership-card.pdf");
        },
        markCardForReissue() {
            this.isRequestedReissue = !this.isRequestedReissue;
        },
        markCardForReissueConfirmed() {
            var self = this;
            self.isProcessing = true;
            svc.markUserCardForReissue().then(response => {
                self.isProcessing = false;
                var allData = response.body;
                if (!allData) {
                    self.$showError("Something went wrong!");
                    return;
                }
                self.isUserMarkedCardForReissue = allData.isSuccess;

                if (!self.isUserMarkedCardForReissue) {
                    if (allData.message) {
                        self.$showError(allData.message);
                    }
                    else {
                        self.$showError();
                    }
                }
                else {
                    self.$showSuccess();
                }

            }, () => {
                self.message = "Something went wrong. Please try again later."
                self.isProcessing = false;
            })
            EventBus.$emit("load-dashboard-data");
        },
        checkIfCardMarkedForReissue() {
            var self = this;
            self.isProcessing = true;
            svc.isUserMarkedCardForReissue().then(response => {
                self.isProcessing = false;
                var allData = response.body;
                if (!allData) {
                    self.$showError("Something went wrong!");
                    return;
                }
                self.isUserMarkedCardForReissue = allData.isSuccess;

            }, () => {
                self.message = "Something went wrong. Please try again later."
                self.isProcessing = false;
            });
        },
        getDateForMembershipPayment(){
            var paymentDate = this.user.membership.paymentDate;
            
            return moment(paymentDate).format("DD-MM-YYYY");
            
        },

        getDateForMembershipExpiry() {
            var paymentDate = this.user.membership.paymentDate;
            var paymentYear = paymentDate.substring(0, 4);

            var currentYearLastDay = moment().endOf('year').format('DD-MM-YYYY');
            var secondYearLastDay = moment().add(1, 'year').endOf('year').format('DD-MM-YYYY');

            var IsCurrentYearMembershipPayment = this.user.membership.isCurrentYearMembershipPayment;

            if (IsCurrentYearMembershipPayment) {
                return currentYearLastDay;
            }

            var IsNextYearMembership = this.user.membership.isNextYearMembership;

            if (IsNextYearMembership) {
                return secondYearLastDay;
            }

            return '';
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$off("user-load-membership-card");
        EventBus.$on("user-load-membership-card", (id) => { self.getData(id); });
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY');
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/membership/membership-card/membership-card.js